/** Payload QR handover — format standar SUPEROTI:<type>:<id>:<token> */

export function buildDeliveryHandoverQrPayload(deliveryId: string, token: string): string {
  return `SUPEROTI:DH:${deliveryId}:${token}`
}

export function buildKitchenTransferHandoverQrPayload(transferId: string, token: string): string {
  return `SUPEROTI:KTH:${transferId}:${token}`
}

export function parseKitchenTransferHandoverQrPayload(
  payload: string,
): { transferId: string; token: string } | null {
  const parsed = parseTypedQrPayload(payload, 'SUPEROTI:KTH:')
  if (!parsed) return null
  return { transferId: parsed.id, token: parsed.token }
}

export function buildReturnPickupQrPayload(returnId: string, token: string): string {
  return `SUPEROTI:RP:${returnId}:${token}`
}

function parseTypedQrPayload(
  payload: string,
  typePrefix: string,
): { id: string; token: string } | null {
  const p = payload.trim()
  if (!p.toUpperCase().startsWith(typePrefix.toUpperCase())) return null
  const rest = p.slice(typePrefix.length)
  const sep = rest.indexOf(':')
  if (sep <= 0) return null
  const id = rest.slice(0, sep).trim()
  const token = rest.slice(sep + 1).trim()
  if (!id || !token) return null
  return { id, token }
}

export function parseReturnPickupQrPayload(payload: string): { returnId: string; token: string } | null {
  const parsed = parseTypedQrPayload(payload, 'SUPEROTI:RP:')
  if (!parsed) return null
  return { returnId: parsed.id, token: parsed.token }
}
